import React, {
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
  useMemo,
} from "react";
import { Link, useNavigate, useLocation, useHistory } from "react-router-dom";

// img
import logo from "../assets/images/icons/dd.png";
import FLOGO from '../assets/images/icons/J.png'

import { motion, useScroll, useSpring } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { GrowthgridsApiList } from "../Services/growthgrids";

function Header() {
  useEffect(() => {
    if (window.location.pathname !== "/services") {
      window.location.hash = "";
      const parts = window?.location?.pathname;
      const newPath = parts?.split("/");
    }
  }, []);

  const [scroll, setScroll] = useState(false);
  const [productMenuActive, setProductMenuActive] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleScroll = () => {
    if (window.scrollY > 150) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useMemo(() => {
    window.addEventListener("scroll", () => {
      // setScroll(window.scrollY > 50);
      handleScroll();
    });

    return () => window.removeEventListener("scroll");
  }, []);



  // Menu hover
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  useEffect(() => {
    activeProductFun();
    setIsHovering(false);
  }, [location.pathname]);

  const activeProductFun = () => {
    if (location.pathname === "/products/tender-grid") {
      setProductMenuActive(true);
    } else {
      setProductMenuActive(false); // Ensure to reset to false if the condition is not met
    }
  };

  // mobile responsive
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  useEffect(() => {
    // Close the menu when the page is navigated
    setIsMenuOpen(false);
    // navigate(location.pathname);
  }, [location.pathname]); // Re-run effect when the pathname changes

  const [megaMenu, setMegaMenu] = useState(false);
  const mobileSubMenu = () => {
    if (window.innerWidth <= 991) {
      setMegaMenu(true);
      setIsHovering(false);
    }
  };
  const closeSubMenu = () => {
    setMegaMenu(false);
  };

  const [pageId, setPageId] = useState(2);




  return (
    <>
      <div
        id={isHovering ? "megaMenuActive" : null}
        className={scroll ? "gg-header jwpnavbar--scrolled" : "gg-header"}
      >
        <div className="gg-container">
          <div className="gg-grid">
            <div className="gg-col-sm-3 gg-col-6">
              <div className="gg-flex">
                <Link
                  to={"/"}
                  className="brandLogo"
                  onClick={() => setPageId(2)}
                >
               
                  
                  <img
                    src={productMenuActive ? FLOGO : FLOGO}
                    className="hideScroll"
                    alt="logo light"
                  />
                  <img src={FLOGO} className="showScroll" alt="logo" />
                  {/* <h1 className="hideScroll   ">Jaladhija</h1> */}
                </Link>
              </div>
            </div>
            <div className="gg-col-sm-9 gg-col-6">
              <div className={`endNav ${isMenuOpen ? "menuOpen" : ""}`}>
                <div className="mobileHead hideDesktop">
                  <img src={FLOGO} alt="logo dark" />
                  {/* <h3>jaladhija</h3> */}
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={closeMenu}
                  >
                    <path
                      d="M18.5342 6.94531L6.53418 18.9453"
                      stroke="#3D3D3D"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.53418 6.94531L18.5342 18.9453"
                      stroke="#3D3D3D"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                
                <Link
                  to={"/product"}
                  id={isActive("/product")}
                  className="link"
                  style={productMenuActive ? { color: "#545454" } : null}
                  onClick={() => setPageId(3)}
                >
                 Products
                </Link>

                <Link
                  to={"/about-us"}
                  id={isActive("/about")}
                  className="link"
                  style={productMenuActive ? { color: "#545454" } : null}
                  onClick={() => setPageId(3)}
                >
                  About Company
                </Link>
                <Link
                  to={"/careers"}
                  id={isActive("/careers")}
                  className="link"
                  style={productMenuActive ? { color: "#545454" } : null}
                  onClick={() => setPageId(4)}
                >
                  Careers
                </Link>
                {/*    */}
                <Link
                  to={"/contact-us"}
                  id={isActive("/contact-us")}
                  className="gg-mainButton"
                  onClick={() => setPageId(6)}
                >
                  Contact Us
                </Link>
              </div>
              {/* <!-- ./endNav --> */}
              <div class="mobile__menuTrigger" onClick={toggleMenu}>
                <svg
                  width="20"
                  class="openmenu"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 30 30"
                >
                  <path class="top" d="M0 9h30v2H0z"></path>
                  <path class="bot" d="M0 19h30v2H0z"></path>
                </svg>
                View Menu
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <motion.div className="scrollProgress_bar" style={{ scaleX }} /> */}
      <div
        className={
          isHovering
            ? "productMenu show"
            : megaMenu
            ? "productMenu mobileMegaMenu"
            : "productMenu"
        }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        <div className="goBack_menu" onClick={closeSubMenu}>
          <svg
            width="46"
            height="24"
            viewBox="0 0 46 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M39.7744 11.804H4.77441"
              stroke="#8B8B8B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.7744 18.804L4.77441 11.804L11.7744 4.80396"
              stroke="#8B8B8B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Our Products
        </div>
      </div>
      {/* ./productMenu */}
    </>
  );
}

export default Header;
